import { render, staticRenderFns } from "./ComponentRowColumnsMenu.vue?vue&type=template&id=1a5462d1&"
import script from "./ComponentRowColumnsMenu.vue?vue&type=script&lang=js&"
export * from "./ComponentRowColumnsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports